exports.API_URL = "https://api.ecstech.com.br/api/";
exports.MIN_EMPRESTIMO = 50.0;
exports.MIN_PRESTACAO = 10.0;
exports.TAXA = 5.0;
exports.ACRESCIMO = 2.0;
exports.NUM_MAX_PARCELAS = 10;
